import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

const LABEL = { calmer: "Calmer", "more confident": "More confident", lighter: "Lighter", same: "About the same", unsettled: "Unsettled" };
const SHADE = { calmer: "#8FB98A", "more confident": "#D9B26A", lighter: "#4FB6C4", same: "#6B7280", unsettled: "#B07A7A" };

// How each immersion has left people feeling, from their spoken check-ins. `admin` = across all members.
export default function ImmersionInsights({ admin = false }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(admin ? "/admin/immersion-insights" : "/immersions/insights/mine").then((r) => setD(r.data)).catch(() => {}); }, [admin]);
  if (!d || (!admin && !d.total)) return null;
  return (
    <section className="mb-10 rounded-3xl border border-white/10 bg-card/40 p-6 sm:p-7" data-testid={admin ? "admin-immersion-insights" : "immersion-insights"}>
      <p className="text-[10px] uppercase tracking-[0.22em] text-primary">{admin ? "Feelings insights · all members" : "How immersions leave you"}</p>
      <p className="text-sm text-muted-foreground mt-1 mb-5">{d.total} spoken check-in{d.total === 1 ? "" : "s"}</p>
      {!d.items.length && <p className="text-sm text-muted-foreground" data-testid="insights-empty">No check-ins yet.</p>}
      <div className="space-y-5">
        {d.items.map((it) => (
          <div key={it.id} data-testid={`insight-${it.id}`}>
            <div className="flex items-baseline justify-between mb-2">
              <span className="font-serif text-lg">{it.title}</span>
              <span className="text-xs text-muted-foreground">Mostly <span className="text-foreground" data-testid={`insight-top-${it.id}`}>{LABEL[it.top].toLowerCase()}</span> · {it.total}</span>
            </div>
            <div className="flex h-2 rounded-full overflow-hidden bg-white/5">
              {d.feelings.filter((f) => it.feelings[f]).map((f) => (
                <div key={f} title={`${LABEL[f]}: ${it.feelings[f]}`} style={{ width: `${(it.feelings[f] / it.total) * 100}%`, background: SHADE[f] }} />
              ))}
            </div>
          </div>
        ))}
      </div>
      {d.items.length > 0 && (
        <div className="flex flex-wrap gap-x-4 gap-y-1 mt-5">
          {d.feelings.map((f) => <span key={f} className="text-[11px] text-muted-foreground flex items-center gap-1.5"><i className="w-2 h-2 rounded-full inline-block" style={{ background: SHADE[f] }} />{LABEL[f]}</span>)}
        </div>
      )}
    </section>
  );
}
